import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { IconClock } from '../atoms/Icon';

const DAYS = [
  { key: 'monday', label: 'Segunda-feira' },
  { key: 'tuesday', label: 'Terça-feira' },
  { key: 'wednesday', label: 'Quarta-feira' },
  { key: 'thursday', label: 'Quinta-feira' },
  { key: 'friday', label: 'Sexta-feira' },
  { key: 'saturday', label: 'Sábado' },
  { key: 'sunday', label: 'Domingo' },
];

const DEFAULT_DAY = { isOpen: true, opensAt: '08:00', closesAt: '18:00' };

export function buildHours(existing) {
  const hours = {};
  for (const { key } of DAYS) {
    hours[key] = { ...DEFAULT_DAY, ...(existing?.[key] || {}) };
  }
  return hours;
}

/** Dia fechado compara só o `isOpen` — os horários guardados ficam irrelevantes
 *  e comparar todos eles marcaria a tela como alterada sem o usuário ter mexido. */
export function sameBusinessHours(a, b) {
  return DAYS.every(({ key }) => {
    const x = a[key];
    const y = b[key];
    if (x.isOpen !== y.isOpen) return false;
    if (!x.isOpen) return true;
    return x.opensAt === y.opensAt && x.closesAt === y.closesAt;
  });
}

function openDaysSummary(hours) {
  const open = DAYS.filter(({ key }) => hours[key].isOpen).length;
  if (open === 0) return 'Nenhum dia aberto';
  if (open === DAYS.length) return 'Aberto todos os dias';
  return `Aberto em ${open} de ${DAYS.length} dias`;
}

function BusinessHoursForm({ value, onChange }) {
  function updateDay(key, patch) {
    onChange({ ...value, [key]: { ...value[key], ...patch } });
  }

  return (
    <Card className="border-0 card-elevated" style={{ borderRadius: 'var(--radius-md)' }}>
      <Card.Body className="p-4">
        <div className="d-flex align-items-center justify-content-between gap-2 mb-1 flex-wrap">
          <div className="d-flex align-items-center gap-2">
            <IconClock size={16} style={{ color: 'var(--color-purple-primary)' }} />
            <h6 className="fw-semibold mb-0" style={{ color: 'var(--color-neutral)' }}>
              Horário de funcionamento
            </h6>
          </div>
          <span style={{ fontSize: 12, color: '#888' }}>{openDaysSummary(value)}</span>
        </div>
        <p className="mb-3" style={{ fontSize: 12, color: '#888' }}>
          Defina os dias e horários em que o estabelecimento recebe pedidos.
        </p>

        <div>
          {DAYS.map(({ key, label }) => {
            const day = value[key];
            return (
              <div key={key} className={`hours-row${day.isOpen ? '' : ' closed'}`}>
                <Form.Check
                  type="switch"
                  checked={day.isOpen}
                  onChange={(e) => {
                    const isOpen = e.target.checked;
                    updateDay(key, {
                      isOpen,
                      opensAt: isOpen ? day.opensAt || DEFAULT_DAY.opensAt : day.opensAt,
                      closesAt: isOpen ? day.closesAt || DEFAULT_DAY.closesAt : day.closesAt,
                    });
                  }}
                  title={day.isOpen ? 'Aberto' : 'Fechado'}
                  aria-label={`${label}: ${day.isOpen ? 'aberto' : 'fechado'}`}
                />
                <div className="hours-row-day">{label}</div>

                {day.isOpen ? (
                  <div className="d-flex align-items-center gap-2">
                    <Form.Control
                      type="time"
                      size="sm"
                      value={day.opensAt || ''}
                      onChange={(e) => updateDay(key, { opensAt: e.target.value })}
                      aria-label={`${label}: abre às`}
                      className="hours-time"
                    />
                    <span style={{ fontSize: 12, color: '#aaa' }}>até</span>
                    <Form.Control
                      type="time"
                      size="sm"
                      value={day.closesAt || ''}
                      onChange={(e) => updateDay(key, { closesAt: e.target.value })}
                      aria-label={`${label}: fecha às`}
                      className="hours-time"
                    />
                  </div>
                ) : (
                  <span style={{ fontSize: 12.5, color: '#bbb' }}>Fechado</span>
                )}
              </div>
            );
          })}
        </div>
      </Card.Body>
    </Card>
  );
}

export default BusinessHoursForm;
